import clsx from 'clsx';
import React from 'react';

import type { ExpertsBlockProps } from '../interfaces';
import Experts from './Experts';

const ExpertsBlock = ({ config, reporters }: ExpertsBlockProps) => {
  return (
    <div className={clsx(config?.css_classes)} data-testid="experts-block">
      <Experts reporters={reporters} config={config} />
    </div>
  );
};

export default ExpertsBlock;
